// eslint-disable-next-line no-restricted-imports
import styled from '@emotion/styled';
import {
  Flex,
  Hide,
  SortDownIcon,
  SortUpIcon,
  Typography,
} from '@iheartjane/reefer';
import type { ReactNode } from 'react';
import { useState } from 'react';

const StyledFlex = styled(Flex)<{ isCollapsed?: boolean }>(
  ({ theme, isCollapsed }) => ({
    backgroundColor: theme.colors.grays.ultralight,
    padding: '16px 8px',
    borderTop: `1px solid ${theme.colors.grays.light}`,
    borderBottom: isCollapsed
      ? 'none'
      : `1px solid ${theme.colors.grays.light}`,
  })
);

export const ExpandableNav = ({
  children,
  title,
}: {
  children: ReactNode;
  title: string;
}) => {
  const [isHidden, setIsHidden] = useState(false);
  return (
    <>
      <StyledFlex
        isCollapsed={isHidden}
        ariaLabel={title}
        onClick={() => setIsHidden(!isHidden)}
      >
        {isHidden ? <SortUpIcon /> : <SortDownIcon />}
        <Typography ml={8} variant="body-bold">
          {title}
        </Typography>
      </StyledFlex>
      <Hide isHidden={isHidden}>{children}</Hide>
    </>
  );
};
